import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { PlanTypes, GeneralTypes } from "@/types";

export interface PlanSearchState {
  planSearchOptions: GeneralTypes.QueryOptions;
  planSearchResults: PlanTypes.PlanSearchResponse;
}

const DEFAULT_PLAN_SEARCH_STATE: PlanSearchState = {
  planSearchOptions: {
    full_text_search: "",
    order_by: [{ coverage_strategy_id: GeneralTypes.SortOrder.Asc }],
    page_number: 1,
    results_per_page: 20,
  },
  planSearchResults: {
    results: [],
    result_count: "0",
  },
};

export default (state: PlanSearchState = DEFAULT_PLAN_SEARCH_STATE, action: Action): PlanSearchState => {
  if (action.type === ActionTypes.SEARCH_FOR_PLAN_LIST) {
    return {
      ...state,
      planSearchOptions: action.payload,
    };
  } else if (action.type === ActionTypes.SEARCH_FOR_PLAN_LIST_RESULTS) {
    return {
      ...state,
      planSearchResults: action.payload,
    };
  } else {
    return state;
  }
};
